import {Injectable} from '@angular/core';

@Injectable({
  providedIn: 'root',
})
export class SsrContext {
  
  /**
   * Détecte si l'application s'exécute côté serveur (SSR)
   */
  isServer(): boolean {
    // Détection multi-niveaux Express/Node.js
    const noWindow = typeof window === 'undefined';
    const hasNode = typeof process !== 'undefined' && !!process.versions && !!process.versions.node;
    const hasGlobalThis = typeof globalThis !== 'undefined';
    
    return noWindow && (hasNode || hasGlobalThis);
  }

  /**
   * Détecte si l'application s'exécute côté client (navigateur)
   */
  isBrowser(): boolean {
    return !this.isServer();
  }

  /**
   * Détecte spécifiquement l'environnement Express SSR
   */
  isExpress(): boolean {
    // Détection spécifique Express via marqueur
    return this.isServer() && 
           typeof globalThis !== 'undefined' && 
           globalThis.__EXPRESS_SSR__ === true;
  }

  /**
   * Détecte si l'application s'exécute dans Puppeteer (rendu SSR)
   */
  isPuppeteer(): boolean {
    return this.isServer() && 
           typeof globalThis !== 'undefined' && 
           (globalThis.__PUPPETEER__ === true || globalThis.navigator?.webdriver === true);
  }

  /**
   * Récupère des données SSR depuis le contexte global
   */
  getSsrData<T>(key: string): T | undefined {
    if (this.isServer() && typeof globalThis !== 'undefined') {
      return globalThis[`__SSR_${key}__`] as T;
    }
    return undefined;
  }

  /**
   * Définit des données SSR dans le contexte global
   */
  setSsrData<T>(key: string, value: T): void {
    if (this.isServer() && typeof globalThis !== 'undefined') {
      globalThis[`__SSR_${key}__`] = value;
    }
  }

  /**
   * Récupère les cookies SSR
   */
  getSsrCookies(): Record<string, string> {
    return this.getSsrData<Record<string, string>>('COOKIES') || {};
  }

  /**
   * Définit le code de statut HTTP en SSR
   */
  setSsrStatusCode(statusCode: number): void {
    this.setSsrData('STATUS_CODE', statusCode);
  }

  /**
   * Récupère le code de statut HTTP en SSR
   */
  getSsrStatusCode(): number | undefined {
    return this.getSsrData<number>('STATUS_CODE');
  }
}
